import { ControlStatus } from '@/gen/controls/v1/control_status_pb'

import { useFeatureFlagEnabled } from '@/lib/config/featureflag'
import { SELECTABLE_CONTROL_STATUSES } from '@/lib/control-status'

const WITHOUT_ATTESTED = SELECTABLE_CONTROL_STATUSES.filter(
  (status) => status !== ControlStatus.ATTESTED,
)

/** Statuses already set stay visible everywhere they render, since those surfaces follow the data. */
export const useSelectableControlStatuses = (hasAttestation = false): readonly ControlStatus[] =>
  useFeatureFlagEnabled('vendor-attested-status').isEnabled || hasAttestation
    ? SELECTABLE_CONTROL_STATUSES
    : WITHOUT_ATTESTED
